import { render, staticRenderFns } from "./ReopenEncounter.vue?vue&type=template&id=73b68dd6&"
import script from "./ReopenEncounter.vue?vue&type=script&lang=js&"
export * from "./ReopenEncounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports